import React from 'react';

import styled from '@emotion/styled';

import { COLORS, FontWeight, mq } from '@clutter/clean';

import { TOKENS } from '@root/components/www/home/tokens';

import { CustomLink } from '@shared/custom_link';

import logoDark from '@images/home/logo-clutter-dark.svg';

const HeaderBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLORS.grayBackground};
  padding: 20px 24px;

  ${mq({
    padding: ['20px 24px', null, '24px 48px'],
  })}
`;

const LogoLink = styled(CustomLink)`
  display: inline-flex;
  flex-shrink: 0;
`;

const Logo = styled.img`
  height: 28px;
  width: 96px;
  min-width: 96px;
  object-fit: contain;
`;

const SaveExitLink = styled(CustomLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${TOKENS.radius.pill};
  border: 1px solid ${COLORS.grayBorder};
  background: ${COLORS.cloud};
  padding: 12px 24px;
  font-family: ${TOKENS.font.sans};
  font-size: 16px;
  font-weight: ${FontWeight.Medium};
  line-height: 1.2;
  color: ${TOKENS.color.foreground};
  text-decoration: none;
  white-space: nowrap;

  ${mq({
    fontSize: ['16px', null, '18px'],
  })}

  &:hover {
    opacity: 0.85;
  }
`;

export const StorageProductHeader: React.FC = () => (
  <HeaderBar>
    <LogoLink to="/" aria-label="Clutter home">
      <Logo src={logoDark} alt="Clutter" />
    </LogoLink>
    <SaveExitLink to="/">Save and exit</SaveExitLink>
  </HeaderBar>
);
